import { render, staticRenderFns } from "./AdminProdStatus.vue?vue&type=template&id=51ef049d&scoped=true&"
import script from "./AdminProdStatus.vue?vue&type=script&lang=js&"
export * from "./AdminProdStatus.vue?vue&type=script&lang=js&"
import style0 from "./AdminProdStatus.vue?vue&type=style&index=0&id=51ef049d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ef049d",
  null
  
)

export default component.exports